// extracted by mini-css-extract-plugin
export default {"infoCardGrid":"InfoCardGrid_infoCardGrid__mEpn1"};